<template>
  <div id="root">
    <div class="fixed-background">
      <main>
        <div class="container">
          <b-row class="h-100">
            <b-colxx xxs="12" md="10" class="mx-auto my-auto">
              <b-card class="auth-card" no-body>
                <div class="position-relative image-side">
                  <p class=" text-white h2">TableNjoy Brand Admin</p>
                </div>
                <div class="form-side">
                  <h1 class="mb-4" style="color:red">현재 모바일로 지원하지 않는 기능입니다.</h1>
                  <p class="mb-0 text-muted text-small mb-0">
                  </p>
                  <p class="display-1 font-weight-bold mb-5"></p>
                  <span style="color:red">PC로 접속하여 확인해 주세요.</span>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileError",
  methods: {
  },
  mounted: function () {
    document.body.classList.add("background");
  },
  beforeDestroy() {
    document.body.classList.remove("background");
  }
}
</script>

<style scoped>

</style>
